function getCookie(searchFor) {
  var i, name, value
  var cookieArr = document.cookie.split(';')
  var cookieRes = []
  for (i = 0; i < cookieArr.length; i++) {
    name = cookieArr[i].substr(0, cookieArr[i].indexOf('='))
    value = cookieArr[i].substr(cookieArr[i].indexOf('=') + 1)
    name = name.replace(/^\s+|\s+$/g, '')
    if (name.search(searchFor) >= 0) {
      var str = unescape(value)
      var productJSON
      try {
        productJSON = JSON.parse(str)
      } catch (e) {
        productJSON = str
      }
      cookieRes.push(productJSON)
    }
  }
  return cookieRes
}

function setCookie(cookieName, value, expDate, domain, path) {
  path = path || '/'
  domain = domain || '.yatra.com'
  var cookieValue = escape(value) + (expDate == null ? '' : '; expires=' + expDate.toUTCString()) + '; path=' + path + ';domain =' + domain
  // document.cookie = cookieName + '=' + cookieValue
  document.cookie = cookieName + '=' + cookieValue
}

function deleteCookie(cookieName) {
  var expDate = new Date()
  expDate.setDate(expDate.getDate() - 1)
  setCookie(cookieName, '', expDate)
}

var shortListCookieName = 'SHORTLIST-PACKAGE-'
var shortListedPackages = getCookie(shortListCookieName) || []
var canShortList = true

export default {
  methods: {
    getShortListedPackages: function() {
      shortListedPackages = getCookie(shortListCookieName) || []
      return shortListedPackages
    },
    setShortListedPackages: function(data) {
      shortListedPackages.push(data)
    },
    canShortListPackage: function(booleanval) {
      canShortList = booleanval
    },
    ifCanShortListPackage: function() {
      return canShortList
    },
    getShortListedPackagesLength: function() {
      return shortListedPackages.length
    },
    shortListPackage: function(packageData) {
      if (this.getShortListedPackages().length < 3) {
        var expDate = new Date()
        expDate.setDate(expDate.getDate() + 30)
        this.setShortListedPackages(packageData)
        var packageDetails = {
          packageId: packageData.packageId,
          packageTitle: packageData.packageTitle,
          packageDuration: packageData.packageDuration,
          startFromPrice: packageData.startFromPrice,
          defaultSrpimg: packageData.defaultSrpimg,
          vendorName: packageData.vendorName
        }
        setCookie(shortListCookieName + packageData.packageId, JSON.stringify(packageDetails), expDate)
        this.canShortListPackage(true)
        return true
      } else {
        this.canShortListPackage(false)
        return false
      }
    },
    isShortListed: function(packageId) {
      var searchFor = shortListCookieName + packageId
      var cookieRes = getCookie(searchFor)
      if (cookieRes != null && cookieRes.length !== 0) {
        return true
      } else {
        return false
      }
    },
    removeFromShortList: function(packageId) {
      deleteCookie(shortListCookieName + packageId)
      for (var i = 0; i < shortListedPackages.length; i++) {
        if (shortListedPackages[i].packageId === packageId) {
          shortListedPackages.splice(i, 1)
          this.canShortListPackage(true)
          break
        }
      }
    },
    addOrRemoveShortList: function(pkg) {
      if (!this.isShortListed(pkg.packageId)) {
        var shortListed = this.shortListPackage(pkg)
        if (!shortListed) {
          this.showShortListError()
        }
      } else {
        this.removeFromShortList(pkg.packageId)
      }
      this.$forceUpdate()
      this.$emit('packageCompareToggled')
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/cookie.js